import OrderOptimizerTaxiDetailsHiddenDetailsDriver from "../types/order-optimizer-taxi-details-hidden-details-driver";
import { OrderOptimizerTaxiDetailsHiddenDetailsDriverListItem } from "../types/order-optimizer-taxi-details-hidden-details-driver-list";
import OrderOptimizerTaxiDetailsHiddenDetailsDriverSelectOption from "../types/order-optimizer-taxi-details-hidden-details-driver-select-option";

const createPotentialDriver = (
  potentialDriver: OrderOptimizerTaxiDetailsHiddenDetailsDriverListItem
): OrderOptimizerTaxiDetailsHiddenDetailsDriver => {
  return {
    driver: potentialDriver.driver,
    taxiDriverAssociationUuid: potentialDriver.taxiDriverAssociationUuid,
    saDistance: potentialDriver.saDistance,
    taxiCorporation: potentialDriver.taxiCorporation,
  };
};

const createPotentialDriverSelectOption = (
  potentialDriver: OrderOptimizerTaxiDetailsHiddenDetailsDriver
): OrderOptimizerTaxiDetailsHiddenDetailsDriverSelectOption => {
  return {
    label: potentialDriver.driver,
    subText: potentialDriver.taxiCorporation,
    value: potentialDriver,
  };
};

const createPotentialDriverSelectOptions = (
  data: OrderOptimizerTaxiDetailsHiddenDetailsDriverListItem[]
): OrderOptimizerTaxiDetailsHiddenDetailsDriverSelectOption[] => {
  const workers = data.map(createPotentialDriver);
  return workers.map(createPotentialDriverSelectOption);
};

const orderOptimizerTaxiDetailsHiddenDetailsDriverFactory = {
  createPotentialDriverSelectOption,
  createPotentialDriverSelectOptions,
};

export default orderOptimizerTaxiDetailsHiddenDetailsDriverFactory;
